import { makeStyles } from '@material-ui/core';
import { rem, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  component: {
    textAlign: 'center',
  },
  dialogPaper: {
    background: themeColor.modalBackground,
  },
  icon: {
    borderRadius: '50%',
    width: '1.75rem',
    height: '1.75rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '1vw',
  },
  barinfo: {
    backgroundColor: theme.palette.primary.main,
  },
  info: {
    color: theme.palette.primary.main,
  },
  title: {
    fontSize: rem(2),
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  message: {
    color: themeColor.blackish,
    fontSize: rem(1.125),
    fontWeight: 500,
    paddingLeft: '1vw',
    paddingRight: '1vw',
  },

  tenderLine: {
    color: theme.palette.primary.main,
    lineHeight: rem(1.6875),
    flexWrap: 'nowrap',
    columnGap: vw(3.15),

    '& div:last-child': {
      textAlign: 'right',
    },
  },

  tenderName: {
    fontSize: rem(0.875),
    color: themeColor.palesky,
    flexGrow: 1,
    textAlign: 'left',
    padding: 0,
  },

  receiptInfo: {
    color: themeColor.defaultTextColor,
    fontSize: rem(1),
    fontWeight: 500,
    marginBottom: '5vh',
  },
  bar: {
    width: '5vw',
    height: '1vh',
    margin: 'auto',
    marginBottom: '5vh',
  },
  cart: {
    margin: '0px auto',
    marginBottom: '2vh',
    marginRight: '5.6rem',
    '@media(width: 1024px) and (height: 576px)': {
      transform: 'scale(0.75) translate(10px, -30px)',
    },
  },
  header: {
    backgroundColor: themeColor.white,
    height: '9vh',
    marginBottom: '5vh',
    fontSize: rem(1.125),
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    paddingLeft: rem(0.875),
    paddingRight: rem(0.375),
  },
  cashbackHeader: {
    fontSize: rem(1.375),
    letterSpacing: rem(0.015),
    color: themeColor.subheaderLight,
  },
  spacing: {
    marginLeft: '1vw',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  noWrap: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tenderWindow: {
    width: '47%',
  },
  multiRow: {
    height: rem(5.0625),
    '@media(width: 1024px) and (height: 576px)': {
      height: rem(3.375),
    },
  },
  doubleRow: {
    height: rem(3.375),
  },
  singleRow: {
    height: rem(1.6875),
  },
}));
